import styled from "styled-components";

const LogoImage = styled.img`
  width: 100%;
`

const Logo = () => {
  return (
    <LogoImage src="/images/logo.png" alt="RPRP" />
  )
}

export default Logo;
